import type { Relationship } from '@customerio/hydra-ui-api';
import type { Customer } from '@/services/db/customer/entity';

/** Either end of a relationship, whichever slot the caller needs to read. */
type RelationshipEntities = Pick<Relationship, 'entity1_id' | 'entity2_id'>;

/** The person on the other side of the relationship, whichever entity slot holds it. */
export function relationshipCustomer(
  relationship: RelationshipEntities,
  cioObjectId: string,
  customersByCioId: Map<string, Customer>,
): Customer | undefined {
  const personId = relationship.entity1_id === cioObjectId ? relationship.entity2_id : relationship.entity1_id;
  return customersByCioId.get(personId);
}

/** Stable identity for a relationship row: the API models the pair, not an id. */
export function relationshipKey(relationship: RelationshipEntities): string {
  return `${relationship.entity1_id}:${relationship.entity2_id}`;
}
